import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function getAllGCals(): Promise<CalendarEntry[]> {
  const res = await fetchOrchidAPI(
    "/api/scheduler_calendar_integrations/google_calendars",
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }
  return res.json();
}
